import { Box, Container, Grid, Paper } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import ClaimedEmployeeDetails from '../../../../../claim-view/claimed-employee-details';
import TabBar from '../../../../../../atoms/Tabs/TabBar';
import AddTDSForm from './add-tds-form/add-tds-form';

const ManageCompBenBuilderFormTab = (props) => {
  const [viewMode, setViewMode] = useState(false);
  const paths = location.pathname.split('/');
  const idForDetails = Number(paths[paths.length - 1]);
  const [data, setData] = useState();
  const moduleId = Number(paths[paths.length - 2]);
  const [headerData, setHeaderData] = useState({});

  const { isMobile } = useSelector((state) => state.main);

  const claimsTab = [
    {
      name: 'tds',
      label: data?.name || 'New Form',
      title: data?.name || 'New Form',
      hide: false,
      panel: (
        <AddTDSForm
          viewMode={viewMode}
          setViewMode={setViewMode}
          setData={setData}
          setHeaderData={setHeaderData}
        />
      ),
    },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Container>
        <Grid container>
          {viewMode ? (
            <ClaimedEmployeeDetails employee={headerData} name='Applicant'/>
          ) : (
            <ClaimedEmployeeDetails
              employee={!isEmpty(headerData) ? headerData : '' } name='Applicant'
            />
          )}
          <Box sx={{ flexGrow: 1, width: '100%' }}>
            <TabBar
              tabPanels={claimsTab}
              searchTabs={!isMobile}
              disableCreate
              isScroll={false}
            />
          </Box>
        </Grid>
      </Container>
    </Box>
  );
};

export default ManageCompBenBuilderFormTab;
